// boecompleteset.js · "השלימי את הסט"
//
// מחליף את קמפיין Fixed Bundle של Adoric. שני המוצרים במחיר מלא, בלי הנחה,
// בדיוק כמו אצלם (`discType: "none"`).
//
// המבנה לפי בקשת דליה (06/10): קודם המוצר עצמו עם תמונה, שם, כמות, מידה וצבע,
// ואז הכותרת "השלימי את הסט" והסט עצמו עם הסימון בתוכו. אין "יחיד" ואין
// "המחיר המקורי": שתי האפשרויות הן שתי דרכים לקנות, לא ברירת מחדל וחריג.
//

const DATA_EL = "boe-cs-data";
const MAX_QTY = 10;

const money = (agorot) =>
  "₪" + (agorot / 100).toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const CSS = `
.boe-cs{direction:rtl;text-align:right;margin:16px 0;font-family:inherit}
.boe-cs__h{text-align:center;font-size:16px;font-weight:600;color:#705251;margin:16px 0 10px}
.boe-cs__card{padding:14px;border:1px solid #00000029;border-radius:8px;background:#ffffff00;
  cursor:pointer;transition:border-color .15s,background .15s}
.boe-cs__card[data-checked="true"]{border-width:2px;border-color:#705251;background:#fff}
.boe-cs__head{display:flex;align-items:center;gap:10px}
.boe-cs__radio{flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #00000029;position:relative}
.boe-cs__card[data-checked="true"] .boe-cs__radio{border-color:#705251}
.boe-cs__card[data-checked="true"] .boe-cs__radio::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#705251}
.boe-cs__spacer{flex:1 1 auto}
.boe-cs__sum{flex:0 0 auto;font-size:16px;font-weight:600;color:#3A2F25}
.boe-cs__body{margin-top:10px}
.boe-cs__pair{display:flex;align-items:flex-start;gap:8px}
.boe-cs__col{flex:1 1 0;min-width:0;text-align:center}
.boe-cs__plus{flex:0 0 auto;align-self:center;width:26px;height:26px;border-radius:50%;
  background:#705251;color:#FFF9F5;font-size:16px;line-height:26px;text-align:center;font-weight:600}
.boe-cs__img{width:72px;height:72px;object-fit:cover;border-radius:8px;background:#F5EBE0;display:block;margin:0 auto}
.boe-cs__name{display:block;font-size:13px;font-weight:600;color:#3A2F25;line-height:1.3;margin-top:6px}
.boe-cs__amt{display:block;font-size:13px;color:#7A5F4D;margin-top:2px}
.boe-cs__sels{display:flex;gap:6px;margin-top:8px;justify-content:center;flex-wrap:wrap}
.boe-cs__sel{min-width:0;padding:7px 9px;border:1px solid #00000029;border-radius:6px;
  background:#fff;font-family:inherit;font-size:12px;color:#3A2F25}
.boe-cs__chips{display:flex;gap:6px;margin-top:8px;justify-content:center;flex-wrap:wrap}
.boe-cs__chip{padding:7px 10px;border:1px solid #ECE3D8;border-radius:6px;background:#FFF9F5;
  font-size:12px;color:#7A5F4D}
.boe-cs__one{display:flex;align-items:center;gap:12px;text-align:right}
.boe-cs__one .boe-cs__img{margin:0}
.boe-cs__one .boe-cs__name,.boe-cs__one .boe-cs__amt{margin-top:0}
.boe-cs__one .boe-cs__sels{justify-content:flex-start}
.boe-cs__oneinfo{flex:1 1 auto;min-width:0}
`;

function injectCss() {
  if (document.getElementById("boe-cs-css")) return;
  const s = document.createElement("style");
  s.id = "boe-cs-css";
  s.textContent = CSS;
  document.head.appendChild(s);
}

const productForm = () => document.querySelector('form[action*="/cart/add"]:not(.installment)');

function pageVariantId() {
  const fromUrl = new URLSearchParams(location.search).get("variant");
  if (fromUrl) return String(fromUrl).replace(/\D/g, "");
  const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
  return input ? String(input.value).replace(/\D/g, "") : "";
}

const anchor = () =>
  document.querySelector("buy-buttons:not([class*=hidden])") ||
  document.querySelector("buy-buttons") ||
  productForm();

/* ===================== בוררים ===================== */
// אותה לוגיקה בשני המוצרים: הבוררים תלויים זה בזה, כך שאחרי בחירת מידה רשימת
// הצבעים מכילה רק מה שקיים באותה מידה. צירוף שאזל לא מוצע.

function makeSelect(label, onChange) {
  const sel = document.createElement("select");
  sel.className = "boe-cs__sel";
  sel.setAttribute("aria-label", label);
  sel.addEventListener("change", (e) => {
    e.stopPropagation();
    onChange();
  });
  return sel;
}

function fillSelect(sel, values, keep) {
  sel.innerHTML = "";
  for (const v of values) {
    const o = document.createElement("option");
    o.value = v;
    o.textContent = v;
    sel.appendChild(o);
  }
  sel.value = values.indexOf(keep) >= 0 ? keep : values[0];
  sel.style.flexGrow = String(Math.max(1, ...values.map((v) => String(v).length)));
}

function constrain(group, changedIndex) {
  const { product, selects } = group;
  const pinned = changedIndex == null ? null : selects[changedIndex].value;
  selects.forEach((sel, oi) => {
    if (oi === changedIndex) return;
    const valid = [
      ...new Set(
        product.variants
          .filter((v) => v.available && (pinned == null || v.options[changedIndex] === pinned))
          .map((v) => v.options[oi]),
      ),
    ];
    if (valid.length) fillSelect(sel, valid, sel.value);
  });
}

function resolve(group) {
  const wanted = group.selects.map((s) => s.value);
  const hit = group.product.variants.find(
    (v) => v.available && v.options.every((o, i) => o === wanted[i]),
  );
  group.variant = hit || group.product.variants.find((v) => v.available) || null;
}

function buildGroup(state, product, host, opts) {
  const group = { product, selects: [], variant: null, qtySelect: null, onPick: null };
  const wrap = document.createElement("div");
  wrap.className = "boe-cs__sels";

  if (opts && opts.withQuantity) {
    const q = makeSelect("כמות", () => paint(state));
    for (let i = 1; i <= MAX_QTY; i++) {
      const o = document.createElement("option");
      o.value = String(i);
      o.textContent = String(i);
      q.appendChild(o);
    }
    q.value = "1";
    group.qtySelect = q;
    wrap.appendChild(q);
  }

  group.selects = product.optionNames.map((name, oi) => {
    const sel = makeSelect(name, () => {
      constrain(group, oi);
      resolve(group);
      if (group.onPick) group.onPick();
      paint(state);
    });
    wrap.appendChild(sel);
    return sel;
  });
  host.appendChild(wrap);

  // ברירת המחדל היא מה שכבר נבחר למעלה בעמוד, כדי שלא יהיו שתי אמיתות על המסך.
  const seed =
    product.variants.find((v) => String(v.id) === pageVariantId()) ||
    product.variants.find((v) => v.available);
  if (seed) group.selects.forEach((s, i) => fillSelect(s, [seed.options[i]], seed.options[i]));
  constrain(group, null);
  if (seed) group.selects.forEach((s, i) => { if ([...s.options].some((o) => o.value === seed.options[i])) s.value = seed.options[i]; });
  resolve(group);
  return group;
}

const qtyOf = (g) => (g && g.qtySelect ? Number(g.qtySelect.value) : 1);

/* ===================== ציור ===================== */

function paint(state) {
  const box = state.box;
  if (!box) return;
  const oneQty = qtyOf(state.one);
  const onePrice = state.one.variant ? state.one.variant.price : 0;
  const mainPrice = state.setMain.variant ? state.setMain.variant.price : 0;
  const matePrice = state.setMate.variant ? state.setMate.variant.price : 0;

  box.querySelector("[data-cs-one-sum]").textContent = money(onePrice * oneQty);
  box.querySelector("[data-cs-one-amt]").textContent = money(onePrice);
  box.querySelector("[data-cs-set-sum]").textContent = money(mainPrice + matePrice);
  box.querySelector("[data-cs-main-amt]").textContent = money(mainPrice);
  box.querySelector("[data-cs-mate-amt]").textContent = money(matePrice);
}

// מיישרת את החלונית למידה ולצבע שנבחרו בעמוד עצמו. mirror שומר על כרטיסיית
// הסט מסונכרנת, כך שגם שם לא תישאר מידה ישנה.
function reseedFromPage(state) {
  const v = state.data.main.variants.find((x) => String(x.id) === pageVariantId());
  if (!v || !state.one) return;
  state.one.selects.forEach((sel, i) => {
    if ([...sel.options].some((o) => o.value === v.options[i])) sel.value = v.options[i];
  });
  constrain(state.one, 0);
  state.one.selects.forEach((sel, i) => {
    if ([...sel.options].some((o) => o.value === v.options[i])) sel.value = v.options[i];
  });
  resolve(state.one);
  if (state.one.onPick) state.one.onPick();
}

function render(state) {
  const host = anchor();
  if (!host) return;
  const { data } = state;

  const pageVariant = data.main.variants.find((v) => String(v.id) === pageVariantId());
  if (!pageVariant || !pageVariant.available) {
    const old = document.getElementById("boe-cs");
    if (old) old.remove();
    document.documentElement.classList.remove("boe-cs-on");
    state.box = null;
    state.active = false;
    return;
  }
  if (state.box && document.body.contains(state.box)) {
    // הלקוחה שינתה מידה בבורר של התבנית למעלה. עד 07/10 כאן רק צויירו המחירים
    // מחדש, והבוררים של החלונית נשארו על המידה הישנה: מי שבחרה L קיבלה XS בסל.
    // הבחירה למעלה היא האמת, ולכן כל שינוי שלה מזריע מחדש את החלונית.
    reseedFromPage(state);
    paint(state);
    return;
  }

  const box = document.createElement("div");
  box.id = "boe-cs";
  box.className = "boe-cs";
  box.setAttribute("role", "radiogroup");
  box.innerHTML = `
    <div class="boe-cs__card" data-checked="true" data-cs-mode="one">
      <div class="boe-cs__head" role="radio" tabindex="0" aria-checked="true" aria-label="${data.main.title}">
        <span class="boe-cs__radio"></span>
        <span class="boe-cs__spacer"></span>
        <span class="boe-cs__sum" data-cs-one-sum></span>
      </div>
      <div class="boe-cs__body">
        <div class="boe-cs__one">
          ${data.main.image ? `<img class="boe-cs__img" src="${data.main.image}" alt="" loading="lazy">` : ""}
          <span class="boe-cs__oneinfo">
            <span class="boe-cs__name">${data.main.title}</span>
            <span class="boe-cs__amt" data-cs-one-amt></span>
          </span>
        </div>
      </div>
    </div>

    <p class="boe-cs__h">${data.setTitle}</p>

    <div class="boe-cs__card" data-checked="false" data-cs-mode="set">
      <div class="boe-cs__head" role="radio" tabindex="0" aria-checked="false" aria-label="${data.setTitle}">
        <span class="boe-cs__radio"></span>
        <span class="boe-cs__spacer"></span>
        <span class="boe-cs__sum" data-cs-set-sum></span>
      </div>
      <div class="boe-cs__body">
        <div class="boe-cs__pair">
          <div class="boe-cs__col" data-cs-main>
            ${data.main.image ? `<img class="boe-cs__img" src="${data.main.image}" alt="" loading="lazy">` : ""}
            <span class="boe-cs__name">${data.main.title}</span>
            <span class="boe-cs__amt" data-cs-main-amt></span>
          </div>
          <div class="boe-cs__plus" aria-hidden="true">+</div>
          <div class="boe-cs__col" data-cs-mate>
            ${data.mate.image ? `<img class="boe-cs__img" src="${data.mate.image}" alt="" loading="lazy">` : ""}
            <span class="boe-cs__name">${data.mate.title}</span>
            <span class="boe-cs__amt" data-cs-mate-amt></span>
          </div>
        </div>
      </div>
    </div>`;
  host.insertAdjacentElement("beforebegin", box);
  state.box = box;
  state.active = true;
  document.documentElement.classList.add("boe-cs-on");

  state.one = buildGroup(state, data.main, box.querySelector('[data-cs-mode="one"] .boe-cs__one'), {
    withQuantity: true,
  });
  state.setMain = buildGroup(state, data.main, box.querySelector("[data-cs-main]"), {});
  state.setMate = buildGroup(state, data.mate, box.querySelector("[data-cs-mate]"), {});

  // שינוי באחת הכרטיסיות מיישר את השנייה. הערכים נכתבים ישירות בלי לירות
  // change, ולכן אין לולאה בין השתיים.
  const mirror = (src, dst) => {
    src.selects.forEach((sel, i) => {
      if (dst.selects[i] && [...dst.selects[i].options].some((o) => o.value === sel.value)) {
        dst.selects[i].value = sel.value;
      }
    });
    constrain(dst, 0);
    src.selects.forEach((sel, i) => {
      if (dst.selects[i] && [...dst.selects[i].options].some((o) => o.value === sel.value)) {
        dst.selects[i].value = sel.value;
      }
    });
    resolve(dst);
  };
  state.one.onPick = () => mirror(state.one, state.setMain);
  state.setMain.onPick = () => mirror(state.setMain, state.one);

  const cards = [...box.querySelectorAll(".boe-cs__card")];
  for (const card of cards) {
    const pick = () => {
      // 22/10 נגישות: הבחירה (role=radio) על הכותרת של הכרטיס, כדי שבחירת המידה בתוכו לא תהיה "בתוך" כפתור
      cards.forEach((c) => { c.dataset.checked = String(c === card); c.querySelector(".boe-cs__head").setAttribute("aria-checked", String(c === card)); });
      state.mode = card.dataset.csMode;
    };
    card.addEventListener("click", (e) => {
      if (e.target.closest(".boe-cs__sel")) return;
      pick();
    });
    card.querySelector(".boe-cs__head").addEventListener("keydown", (e) => {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        pick();
      }
    });
  }

  paint(state);
  hookAddToCart(state);
}

/* ===================== הוספה לעגלה ===================== */

async function addChoice(state) {
  const items = [];
  if (state.mode === "set") {
    if (!state.setMain.variant || !state.setMate.variant) return fallback();
    items.push({ id: Number(state.setMain.variant.id), quantity: 1 });
    items.push({ id: Number(state.setMate.variant.id), quantity: 1 });
  } else {
    if (!state.one.variant) return fallback();
    items.push({ id: Number(state.one.variant.id), quantity: qtyOf(state.one) });
  }

  try {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!r.ok) throw new Error("add failed");
  } catch {
    return fallback();
  }

  for (const name of ["cart:refresh", "cart:change", "cart:updated", "variant:added"]) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }
  const drawer = document.querySelector("cart-drawer");
  if (drawer && typeof drawer.show === "function") {
    try {
      drawer.show();
      return;
    } catch {
      /* נופלים לעמוד העגלה */
    }
  }
  fallback();
}

const fallback = () => {
  window.location.href = "/cart";
};

function hookAddToCart(state) {
  const form = productForm();
  if (!form || form.dataset.boeCsHooked) return;
  form.dataset.boeCsHooked = "1";
  form.addEventListener(
    "submit",
    (e) => {
      if (!state.active) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addChoice(state);
    },
    true,
  );
}

/* ===================== הפעלה ===================== */

function start() {
  const el = document.getElementById(DATA_EL);
  if (!el) return;
  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch {
    return;
  }
  if (!data.mate || !data.mate.variants.some((v) => v.available)) return;
  injectCss();

  const state = { data, box: null, mode: "one", one: null, setMain: null, setMate: null, active: false };

  let last = null;
  const sync = () => {
    const id = pageVariantId();
    if (id === last) return;
    last = id;
    render(state);
  };
  sync();

  new MutationObserver(sync).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["value", "data-variant-id", "selected"],
  });
  window.addEventListener("popstate", () => {
    last = null;
    sync();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
